import { Format } from "../../../utils/types/generals"
import { RowTable, ServiceLevelList } from "../response"

export const transformList = async ({ response }: { response: ServiceLevelList }): Format<ServiceLevelList, RowTable[]> => {
    return {
        data: response,
        item: [],
        format: response.items?.map(response => ({
            id: response.id?.toString(),
            area: response.area,
            department: response.department,
            description: response.description,
            register: response.name,
        }))
    }
}